// STORAGE KEYS
export const SPLIT_ORDER_INVOICES_LIST_STORAGE_KEY = 'order-split-order-invoices-list';
export const SPLIT_ORDER_INVOICES_LIST_VIEW_KEY = 'tv-order-split-order-invoices-list';
export const SPLIT_ORDER_INVOICES_LIST_FORM_KEY = 'order-split-order-invoices-form';

// EXCEL FILE NAME
export const SPLIT_ORDER_INVOICES_LIST_EXCEL_FILE_NAME = 'Verity-SplitOrderInvoicesList';

// ROUTES
export const SPLIT_ORDER_INVOICES_ROUTE_LIST = 'invoice2.split.list';
export const SPLIT_ORDER_INVOICES_ROUTE_DETAIL = 'invoice2.splitdetail';
